module.exports = {
    api_url: WIPSconfigLocal.api_url,
    image_base_url: WIPSconfigLocal.image_base_url,
    resource_url: WIPSconfigLocal.resource_url,
    pdf_eingang_url: WIPSconfigLocal.pdf_eingang_url,
    pdf_ausgang_url: WIPSconfigLocal.pdf_ausgang_url,
    base_url: WIPSconfigLocal.base_url,
    isWipsAdmin: WIPSconfigLocal.isWipsAdmin,
    mediaType: WIPSconfigLocal.mediaType,
    defaultUser: WIPSconfigLocal.defaultUser,
    defaultPass: WIPSconfigLocal.defaultPass,
    disableLogin: WIPSconfigLocal.disableLogin,
    allowOverride: WIPSconfigLocal.allowOverride,
    font_base_url: WIPSconfigLocal.font_base_url,
    pdf_base_url: WIPSconfigLocal.pdf_base_url,
    sessionUser: WIPSconfigLocal.sessionUser,
    sessionToken: WIPSconfigLocal.sessionToken,
    sessionObject: WIPSconfigLocal.sessionObject,
    enablePasswordPolicy: WIPSconfigLocal.enablePasswordPolicy,
    cryptKey: WIPSconfigLocal.cryptKey,
    encryptApiCalls: WIPSconfigLocal.encryptApiCalls,
    save_file_ftp: WIPSconfigLocal.save_file_ftp,
    disableErrorCatching: WIPSconfigLocal.disableErrorCatching,
    preset_bereich: WIPSconfigLocal.preset_bereich,
    anreiseUrl: WIPSconfigLocal.anreiseUrl,
    befragungPendelnUrl: WIPSconfigLocal.befragungPendelnUrl,
    devFeatures: WIPSconfigLocal.devFeatures,
    devFeaturesMap: WIPSconfigLocal.devFeaturesMap,
    zwh_login_url: WIPSconfigLocal.zwh_login_url,
    orte_file: WIPSconfigLocal.orte_file,
    instance: WIPSconfigLocal.instance,
    brand: WIPSconfigLocal.brand,
    enableVideos: WIPSconfigLocal.enableVideos,
};
